import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { LogOut, User as UserIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuthUser, useLogout } from "../lib/auth";

export function UserMenu() {
  const { data: user } = useAuthUser();
  const logout = useLogout();
  const navigate = useNavigate();

  if (!user) return null;

  const displayName = user.name || user.email;
  const initials = (user.name || user.email || "?")
    .split(/[\s@.]+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          aria-label={`Account: ${user.email}`}
          className="inline-flex h-8 w-8 items-center justify-center overflow-hidden rounded-full border border-border-primary bg-bg-secondary text-xs font-medium text-text-primary transition-colors hover:bg-bg-hover"
        >
          {user.picture ? (
            <img src={user.picture} alt="" className="h-full w-full object-cover" />
          ) : (
            initials || <UserIcon size={14} />
          )}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={6}
          className="z-dropdown min-w-[200px] rounded-md border border-border-primary bg-bg-elevated p-1 shadow-md animate-fade-in"
        >
          <div className="px-2 py-1.5 text-xs">
            <div className="font-medium text-text-primary">{displayName}</div>
            {user.name && (
              <div className="truncate text-text-secondary">{user.email}</div>
            )}
          </div>
          <DropdownMenu.Separator className="my-1 h-px bg-border-primary" />
          <DropdownMenu.Item
            onSelect={() => navigate("/settings/profile")}
            className="flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-text-primary outline-none transition-colors hover:bg-bg-hover"
          >
            <UserIcon size={14} /> Profil
          </DropdownMenu.Item>
          <DropdownMenu.Item
            onSelect={() =>
              logout.mutate(undefined, {
                onSuccess: () => navigate("/login", { replace: true }),
              })
            }
            className="flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-text-primary outline-none transition-colors hover:bg-bg-hover"
          >
            <LogOut size={14} /> Abmelden
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
